export { default } from './TagSearchBar';



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/TagSearchBar/index.js